import React, { Component } from 'react'
import { StatusAlertService } from 'react-status-alert'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import TaskLogUI from './TaskLogUI'

class TaskLogSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deleteMode: false,
      deleteSubmitted: false
    }
  }

  render() {
    return (
      <TaskLogUI
        context={this.props.context}
        messageList={this.props.messageList}
        project={this.props.project}
        taskLog={this.props.taskLog}
        projectUserMap={this.props.projectUserMap}
        // delete
        deleteMode={this.state.deleteMode}
        onDeleteClick={this.onDeleteClick}
        onDeleteSubmit={this.onDeleteSubmit}
        onDeleteCancel={this.onDeleteCancel}
        deleteSubmitted={this.state.deleteSubmitted}
      />
    )
  }

  // delete -----------------------------------
  onDeleteClick = (event) => {
    this.setState({deleteMode: true})
  }

  onDeleteSubmit = (event) => {
    this.setState({deleteSubmitted: true})
    RestApiUtils.delete(this.props.context,
      `/api/tasks/${this.props.task.taskId}/logs/${this.props.taskLog.dateCreatedCreatedBy}`,
      this.deleteCallback, {}
    )
  }

  deleteCallback = response => {
    this.setState({deleteSubmitted: false})

    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }

    let taskLogList = this.props.taskLogList
    let index = taskLogList.findIndex(taskLog => taskLog.dateCreated === this.props.taskLog.dateCreated)
    if (index >= 0) {
      taskLogList.splice(index, 1)
    }

    this.setState({deleteMode: false})
    this.props.onTaskLogListUpdate(taskLogList)

    CacheManager.removeObject(CacheKeys.TaskLogs(this.props.task.taskId))
  }

  handleError(errorList) {
    errorList.forEach(error => {
      if (error.errorCode === 'NotFound') {
        switch (error.objectCode) {
          case 'Task':
            this.props.onForceTaskListRefresh(this.props.task.projectId)
            break
          case 'TaskLog':
            this.props.onForceTaskLogListRefresh(this.props.task.taskId)
            break;
          default:
        }
      }
    })
    StatusAlertService.showError(errorList[0].message, {withCloseIcon: false})
  }

  onDeleteCancel = (event) => {
    this.setState({deleteMode: false})
  }

}

export default TaskLogSF
